import type { SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import type { Observable } from 'rxjs';

import type { CurrentUser, User } from '@core/account-types';
import { TranslatePipe } from '@core/i18n-legacy';
import type { MailboxInboxSelectItem, MailboxInboxSelectValue } from '@recruitee/mailbox-ui';
import { MailboxSelectComponent } from '@recruitee/mailbox-ui';

@Component({
  selector: 'rt-shared-email-provider-picker',
  templateUrl: './shared-email-provider-picker.component.html',
  styleUrls: ['./shared-email-provider-picker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MailboxSelectComponent, TranslatePipe],
})
export class SharedEmailProviderPickerComponent {
  public control = new FormControl();

  @Input({ required: true }) public selectedItem: MailboxInboxSelectValue | null;
  @Input({ required: true }) public items: MailboxInboxSelectItem[];
  @Input({ required: true }) public currentUser: CurrentUser;
  @Input({ required: true }) public users: Record<number | string, User | null>;
  @Input() public disabled: boolean;
  @Input() public canManageCompany: boolean;

  @Output() public selectItem: Observable<MailboxInboxSelectValue> = this.control.valueChanges;

  public ngOnChanges(changes: SimpleChanges) {
    if ('selectedItem' in changes && this.selectedItem) {
      this.control.setValue(this.selectedItem, { emitEvent: false });
    }

    if ('disabled' in changes && this.disabled !== changes.disabled.previousValue) {
      this.disabled ? this.control.disable() : this.control.enable();
    }
  }
}
